/* eslint-disable */
import {
    setActive,
    showHideScores,
    toggleActive,
    getSiblings,
    isInDOM,
    getNextDay,
    getPrevDay,
    isVisible,
    showLoading,
    getCookie,
} from "./helpers";
import { runCalendar } from "./Datepicker";
import { getOdds } from "./Ajax-odds";
import { checkPubgGames } from "../components/pubg-filter";

/* variable
**************************************************************/
let toggleClass = "active";
let arrows = [
    ...document.querySelectorAll(".switches__matches .switch_nav__item"),
];
let switch_1 = document.querySelector("#switch-1");
let checkboxEarlier = document.querySelector(".switches .switches__item_right");
let tabsMatch = document.querySelectorAll(".match-filters__list-item");
let queryVars = {};
let game;
let day;
let event;
let tab;
let tournament;
let isAjaxCalled = false;
let matchesContainer;
let matchList;
let containers;
let loadNext;
let onTornamentPage =
    window.location.pathname.split("/")[2] === "tournament" ? true : false;
let scroll = onTornamentPage ? true : false;
let buttonMore = document.querySelector(".read-more__button");
let page = document.querySelector("#content").getAttribute("data-page");

/* main function to load matches
**************************************************************/
function loadMatchesByEvents(day, game, event, tab, loadNext, scroll) {
    matchesContainer = document.querySelector(`.matches`);
    matchList = matchesContainer.querySelectorAll(".match");
    game = game ? JSON.parse(game) : "";
    tournament = matchesContainer.getAttribute("data-tournament");
    let teamWpId = matchesContainer.getAttribute("data-teamwpid");
    let availableDates = matchesContainer.getAttribute("data-count-load")
        ? ""
        : "show";
    let dataQuery = matchesContainer.querySelector(".data-query");
    let loadmore = dataQuery ? dataQuery.getAttribute("data-loadmore") : "";
    let timezone = getCookie("esg_timezone");

    if (!event) {
        event = document
            .querySelector(".match-filters__list-item.active")
            .getAttribute("data-event");
    }

    if (scroll) {
        queryVars = {
            day: day,
            game: "",
            event: event,
            tournament: tournament,
            page: page,
            availableDates: availableDates,
            teamWpId: "",
            offset: Number(
                document
                    .querySelector(".match-filters__list-item.active")
                    .getAttribute("data-offset")
            ),
            limit: 40,
            loadmore: loadmore,
            timezone: timezone,
        };
    } else {
        queryVars = {
            day: day,
            game: game,
            event: event,
            tournament: tournament,
            page: page,
            availableDates: availableDates,
            teamWpId: teamWpId,
            offset: 0,
            limit: 40,
            loadmore: loadmore,
            timezone: timezone,
        };
    }

    $.ajax({
        type: "POST",
        url: themeVars.adminUrl,
        data: {
            action: "load_matches_event",
            queryVars: queryVars,
        },
        beforeSend: function () {
            dataQuery != null ? dataQuery.setAttribute("data-loading", "yes") : "";
            disableLoadingButtons(true);
            buttonMore != null ? (buttonMore.style.display = "none") : "";

            toggleSwitches(day, event);

            if (game) {
                matchesContainer = document.querySelector(`#matches-${event}`);
                matchList = matchesContainer.querySelectorAll(".match");
            }
            if (!scroll) {
                matchList.forEach(n => n.remove());
            }
            showLoading(matchesContainer, true);
        },
        success: function (result) {
            disableLoadingButtons(false);

            if (game) {
                matchesContainer = document.querySelector(`#matches-${event}`);
            }
            showLoading(matchesContainer, false);

            if (
                (event === "upcoming" && loadNext === true) ||
                (event === "results" && loadNext === true)
            ) {
                continueloadMatches(day, game, event, result, matchesContainer);
            } else {
                if (scroll) {
                    matchesContainer
                        .querySelector(".loading")
                        .insertAdjacentHTML("beforebegin", result);
                } else {
                    matchesContainer.insertAdjacentHTML("afterbegin", result);
                }
            }

            alignTime();
            emptyFlag();
            checkPubgGames();

            let originEvent = event;
            if (tournament) {
                event = "tournament";
            }
            showHideScores(event);

            if (tab === "results") {
                matchesContainer
                    .querySelectorAll(".match")
                    .forEach(el => el.classList.add(toggleClass));
            }

            noGamesFound(event);

            // Tournament page, using for scroll
            if (page === "tournament") {
                document
                    .querySelector(".match-filters__list-item.active")
                    .setAttribute(
                        "data-offset",
                        Number(queryVars.offset) + Number(queryVars.limit)
                    );
            }
            isAjaxCalled = false;
            if (result.length < 150 || queryVars.loadmore === "no") {
                isAjaxCalled = true;
            } else {
                buttonMore != null && originEvent !== 'ongoing' ? (buttonMore.style.display = "block") : "";
            }
            dataQuery != null ? dataQuery.setAttribute("data-loading", "no") : "";

            if (document.querySelector("#datepicker")) {
                runCalendar();
            }

            matchesContainer.setAttribute("data-count-load", 1);
        },
    });
}

/* first load match
**************************************************************/
document.addEventListener("DOMContentLoaded", function () {
    if (!window.location.search) {
        containers = [...document.querySelectorAll(".matches")];

        for (const i in containers) {
            event = containers[i].getAttribute("data-event");
            game = containers[i].getAttribute("data-game");
            day = document
                .querySelector(".days-filter > .today")
                .getAttribute("data-view");

            loadMatchesByEvents(
                day,
                game,
                event,
                (tab = ""),
                (loadNext = true),
                scroll
            );
            updateDayTitle(day, event);
        }
    }
});

/* load more by click (Tournament page)
**************************************************************/
if (buttonMore != null) {
    buttonMore.addEventListener("click", function () {
        if (onTornamentPage) {
            let tab = document.querySelector(".match-filters__list-item.active");
            let event = tab.getAttribute("data-event");
            let game = tab.getAttribute("data-game");
            let day = tab.getAttribute("data-view");
            let loading = document
                .querySelector(".data-query")
                .getAttribute("data-loading");

            if (loading === "no") {
                loadMatchesByEvents(
                    day,
                    game,
                    event,
                    (tab = ""),
                    (loadNext = false),
                    scroll
                );
            }
        }
    });
}

/* load match click by buttons day (.days-filter)
**************************************************************/
let buttonDays = [...document.querySelectorAll(".days-filter button")];
for (const i in buttonDays) {
    buttonDays[i].addEventListener("click", function () {
        setActive(buttonDays[i]);

        containers = [...document.querySelectorAll(".matches")];
        for (const i in containers) {
            event = containers[i].getAttribute("data-event");
            game = containers[i].getAttribute("data-game");
            day = this.getAttribute("data-view");

            updateActiveContainer(day);
            updateActiveTabs(day);
            updateDayTitle(day, event);

            let tabActive = checkActiveTab();
            if (tabActive) {
                tab = tabActive.getAttribute("data-tab");
            }

            loadMatchesByEvents(day, game, event, tab);
            page === 'game' ? getOdds(day) : '';
        }

        let arrowsParent = document.querySelectorAll(".switch_nav");
        for (let i = 0; i < arrowsParent.length; i++) {
            updateDateArrows(day, arrowsParent[i]);
        }
    });
}

/* 
**************************************************************/
function alignTime() {
    $(".match-time").each(function () {
        if ($(this).children().length < 3) {
            $(this)
                .children("time")
                .addClass("not-live");
        }
    });
}

function emptyFlag() {
    $(".team_flag").each(function () {
        if ($(this).attr("src") == "") {
            $(this).addClass("team_flag-empty");
        }
    });
}

/* show current earlier-games
**************************************************************/
if (checkboxEarlier != null) {
    if (switch_1 != null) {
        switch_1.addEventListener("change", function (e) {
            event = this.getAttribute("data-event");
            let allMatches = [
                ...document.body.querySelectorAll(
                    `#matches-${event} .match:not(.prev):not(.next)`
                ),
            ];
            e.target.checked
                ? toggleActive(allMatches, "earlier", "toggle")
                : toggleActive(allMatches, "current", "toggle");

            noGamesFound(event);
        });
    }
}

/* Load match by click SCHEDULE/RESULTS or UPCOMING/ONGOING/RESULTS
**************************************************************/
for (let i = 0; i < tabsMatch.length; i++) {
    tabsMatch[i].addEventListener("click", function () {
        tabsMatch[i].classList.add(toggleClass);
        getSiblings(tabsMatch[i]).forEach(el => el.classList.remove(toggleClass));

        day = this.getAttribute("data-view");
        game = document.querySelector(".matches").getAttribute("data-game");
        event = document.querySelector(".matches").getAttribute("data-event");
        tab = tabsMatch[i].getAttribute("data-tab");

        updateDateArrows(day);
        updateSingleDayTitle(day, event);
        loadMatchesByEvents(day, game, event, tab);

        tabsMatch.length === 2 ? updateStaticCalendarBar(day) : "";
    });
}

/* Load match by click arrows Next, Prev
**************************************************************/
arrows.forEach(item =>
    item.addEventListener("click", function () {
        containers = document.querySelector(".matches");
        day = this.getAttribute("data-view");
        game = containers.getAttribute("data-game");
        event = this.getAttribute("data-event");

        getSiblings(this)[1].disabled = false;
        let checkEvent = event === "results" ? true : false;
        if (checkEvent === true && this.classList.contains("next")) {
            let today = moment().format("YYYY-MM-DD");
            let tomorrow = getNextDay(today, 1);

            let hiddenContainers = document.querySelectorAll(".match-container");
            let elemCount = 0;
            for (let i = 0; i < hiddenContainers.length; i++) {
                if (window.getComputedStyle(hiddenContainers[i]).display === "none") {
                    elemCount++;
                }
            }
            if (day >= tomorrow && elemCount !== 2) {
                this.disabled = true;
            }
        }

        if (this.disabled == false) {
            updateActiveTabs(day);

            let tabActive = checkActiveTab();
            if (tabActive) {
                tab = tabActive.getAttribute("data-tab");
            }

            loadMatchesByEvents(day, game, event, tab, (loadNext = false));
            updateDateArrows(day, this.parentNode);
            updateStaticCalendarBar(day);
            updateSingleDayTitle(day, event);
        }
    })
);

/* Toggle switches (Today’s earlier broadcasts)
**************************************************************/
function toggleSwitches(day, event) {
    if (event === "ongoing" || event === "showall") {
        if (checkboxEarlier != null) {
            let today = moment().format("YYYY-MM-DD");
            let newDay = moment(day).format("YYYY-MM-DD");

            document.querySelector("#switch-1") !== null ? document.querySelector("#switch-1").checked = false : '';
            if (today === newDay) {
                checkboxEarlier.classList.add(toggleClass);
            } else if (today !== newDay) {
                checkboxEarlier.classList.remove(toggleClass);
            }
        }
    }
}

/* Update date-view in next, prev arrows
**************************************************************/
function updateDateArrows(day, parent) {
    parent = parent ? parent : document;
    let arrowNext = parent.querySelector(".switch_nav__item.next");
    let arrowPrev = parent.querySelector(".switch_nav__item.prev");

    if (checkboxEarlier != null) {
        let prevDate = getPrevDay(day, -1);
        let nextDate = getNextDay(day, 1);
        arrowPrev.setAttribute("data-view", prevDate);
        arrowNext.setAttribute("data-view", nextDate);
    }
}

/* update active Tabs
**************************************************************/
function updateActiveTabs(day) {
    let today = moment().format("YYYY-MM-DD");
    let newDay = moment(day).format("YYYY-MM-DD");

    for (let i = 0; i < tabsMatch.length; i++) {
        // in front page
        if (tabsMatch.length == 2) {
            if (newDay >= today) {
                tabsMatch[0].classList.add(toggleClass);
                tabsMatch[1].classList.remove(toggleClass);
            } else {
                tabsMatch[0].classList.remove(toggleClass);
                tabsMatch[1].classList.add(toggleClass);
            }

            // in tournament page
        } else if (tabsMatch.length > 2) {
            if (newDay > today) {
                tabsMatch[0].classList.add(toggleClass);
                tabsMatch[1].classList.remove(toggleClass);
                tabsMatch[2].classList.remove(toggleClass);
            } else if (newDay == today) {
                tabsMatch[0].classList.remove(toggleClass);
                tabsMatch[1].classList.add(toggleClass);
                tabsMatch[2].classList.remove(toggleClass);
            } else {
                tabsMatch[0].classList.remove(toggleClass);
                tabsMatch[1].classList.remove(toggleClass);
                tabsMatch[2].classList.add(toggleClass);
            }
        }
    }
}

/* update active container (using on game page)
**************************************************************/
function updateActiveContainer(day) {
    let matchContainer = document.querySelectorAll(".match-container");

    if (matchContainer.length === 3) {
        let ongoing = document.querySelector(".match-container-ongoing");
        let upcoming = document.querySelector(".match-container-upcoming");
        let results = document.querySelector(".match-container-results");

        let today = moment().format("YYYY-MM-DD");
        let newDay = moment(day).format("YYYY-MM-DD");

        if (newDay > today) {
            ongoing.style.display = "none";
            upcoming.style.display = "block";
            results.style.display = "none";
        } else if (newDay == today) {
            ongoing.style.display = "block";
            upcoming.style.display = "block";
            results.style.display = "block";
        } else {
            ongoing.style.display = "none";
            upcoming.style.display = "none";
            results.style.display = "block";
        }
    }
}
/* update day title above match container
**************************************************************/
function updateDayTitle(day, event) {
    let container = document.querySelectorAll(".match-container");
    let dayTitle = createDayTitle(day);
    let title;

    let count = 0;
    for (let i = 0; i < container.length; i++) {
        if (isVisible(container[i])) {
            count++;
        }
    }

    if (count === 1) {
        title = document.querySelector(`.match-container-${event} .switch_title`);
    } else if (count === 3) {
        title = document.querySelector(`.switch_title__Today`);
        document.querySelector(
            ".match-container-upcoming .switch_title"
        ).innerText =
            "Upcoming";
        document.querySelector(".match-container-results .switch_title").innerText =
            "Results";
    }

    if (isInDOM(title)) {
        title.innerText = dayTitle + ", " + new Date(day).getDate().addSuffix();
    }
}

function updateSingleDayTitle(day, event) {
    let title = document.querySelector(`.match-container-${event} .switch_title`);
    let dayTitle = createDayTitle(day);

    if (isInDOM(title)) {
        title.innerText = dayTitle + ", " + new Date(day).getDate().addSuffix();
    }
}

function createDayTitle(day) {
    let today = moment().format("YYYY-MM-DD");
    let tomorrow = getNextDay(today, 1);
    let yesterday = getPrevDay(today, -1);
    let newDay = moment(day).format("YYYY-MM-DD");
    let dayTitle;

    if (today === newDay) {
        dayTitle = "Today";
    } else if (tomorrow === newDay) {
        dayTitle = "Tomorrow";
    } else if (yesterday === newDay) {
        dayTitle = "Yesterday";
    } else {
        dayTitle = new Date(newDay).getWeekDay();
    }
    return dayTitle;
}

/* Function to check active Tab (SCHEDULE/RESULTS or UPCOMING/ONGOING/RESULTS)
**************************************************************/
function checkActiveTab() {
    let tabActive = document.querySelector(".match-filters__list-item.active");
    if (isInDOM(tabActive)) return tabActive;
}

/* show/hide no games
**************************************************************/
function noGamesFound(event) {
    let matches = document.querySelectorAll(
        `#matches-${event} .match.active:not(.no-matches-${event})`
    );
    let noMatches = document.querySelector(`.no-matches-${event}`);

    if (noMatches !== null) {
        if (matches.length === 0) {
            noMatches.classList.add("active");
        } else {
            noMatches.classList.remove("active");
        }
    }
}

/* update Days Static Calendar Bar & change acive button with date
**************************************************************/
function updateStaticCalendarBar(day) {
    let buttons = document.querySelectorAll(".days-filter.show button");

    if (buttons.length > 0) {
        for (let i = 0; i < 7; i++) {
            if (i == 0) {
                day = getPrevDay(day, -3);
            } else if (i > 0) {
                day = getNextDay(day, 1);
            }

            buttons[i].setAttribute("data-view", day);
            buttons[i].querySelector(".date").innerHTML = `${moment(day).format(
                "DD"
            )}`;
            buttons[i].querySelector(".day-text").innerHTML = `${moment(day).format(
                "ddd"
            )}`;
            i === 3
                ? buttons[i].classList.add("active")
                : buttons[i].classList.remove("active");
        }
    }
}

/* disable/enable buttons to next loading matches
**************************************************************/
function disableLoadingButtons(flag) {
    let activeElement = document.querySelectorAll(".btn-load");

    for (let i = 0; i < activeElement.length; i++) {
        activeElement[i].disabled = flag;
    }
}

/* check response "event = upcoming", if it is empty then load next day
**************************************************************/
function continueloadMatches(day, game, event, result, matchesContainer) {
    if (event === "upcoming") {
        if (result.length < 150) {
            let today = moment().format("YYYY-MM-DD");
            let weekLater = getNextDay(today, 7);
            let nextDay = getNextDay(day, 1);

            if (nextDay < weekLater) {
                loadMatchesByEvents(
                    nextDay,
                    game,
                    event,
                    (tab = ""),
                    (loadNext = true)
                );
            } else {
                matchesContainer.insertAdjacentHTML("afterbegin", result);
            }
        } else {
            matchesContainer.insertAdjacentHTML("afterbegin", result);
        }
    } else if (event === "results") {
        let today = moment().format("YYYY-MM-DD");
        let weekBefore = getPrevDay(today, -7);
        let prevDay = getPrevDay(day, -1);

        if (result.length < 150) {
            if (prevDay > weekBefore) {
                loadMatchesByEvents(
                    prevDay,
                    game,
                    event,
                    (tab = ""),
                    (loadNext = true)
                );
            } else {
                updateDateArrows(
                    getNextDay(prevDay, 1),
                    document.querySelector(".match-container-results .switch_nav")
                );
                matchesContainer.insertAdjacentHTML("afterbegin", result);
            }
        } else {
            updateDateArrows(
                getNextDay(prevDay, 1),
                document.querySelector(".match-container-results .switch_nav")
            );
            matchesContainer.insertAdjacentHTML("afterbegin", result);
        }
    }
}

export {
    loadMatchesByEvents,
    updateActiveTabs,
    updateDateArrows,
    updateActiveContainer,
    updateStaticCalendarBar,
    updateDayTitle,
    updateSingleDayTitle,
};



// WEBPACK FOOTER //
// ./scripts/modules/Ajax-load-matches.js